import { useTranslation } from 'react-i18next'

import { Container } from 'src/components/Container/Container'
import { Image } from 'src/components/Image/Image'
import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'
import { useLocale } from 'src/contexts/LocaleContext'
import { formatDate } from 'src/functions/dates/formatDate'

import styles from './Author.module.scss'

import type { Author as AuthorType } from 'src/types/Author'

export interface AuthorProps {
  author: AuthorType
  date: string
  categoryName?: string
  categoryUrl?: string
}

export const Author = ({ author, date, categoryName = '', categoryUrl = '' }: AuthorProps) => {
  const { t } = useTranslation()
  const { locale } = useLocale()

  const postBy = `${t('cms.blogPost.authorContribution')} `
  const inCategory = ` ${t('cms.blogPost.authorCategory')} `
  const fromDate = ` ${t('cms.blogPost.authorFrom')} ${formatDate(date, locale)}`

  return (
    <Container>
      <div className={styles.content}>
        {author.imageId && (
          <div className={styles.img}>
            <Image
              identifier={author.imageId}
              srcSet={[180, 360]}
              sizes="180px"
              alt={author.name}
              width="180"
              height="180"
            />
          </div>
        )}

        <Text variant="p" small center suppressHydrationWarning>
          {postBy}
          <strong>{author.name}</strong>
          {categoryName && categoryUrl && (
            <>
              {inCategory}
              <Link href={categoryUrl}>{categoryName}</Link>
            </>
          )}
          {fromDate}
        </Text>
      </div>
    </Container>
  )
}
